import React, { useId } from 'react';

import { TextField } from '@mui/material';

import { Field } from '../shared/Field/Field';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  inputProps?: Omit<React.ComponentProps<typeof TextField>, 'variant'>;
};

function TextInput({ label, value, onChange, inputProps }: Readonly<Props>) {
  const id = useId();

  return (
    <Field label={label} fullWidth tooltip={`Enter ${label.toLowerCase()}`}>
      <TextField
        id={id}
        variant="outlined"
        value={value}
        size="small"
        onChange={(e: { target: { value: string } }) => onChange(e.target.value)}
        {...inputProps}
      />
    </Field>
  );
}

export default TextInput;
